import Tier from './Tier/Tier';
import * as actions from '../PASActions';

const Tier2 = ({ dispatch, save, fields }) => {
    return (
        <div>
            <div className="pt-4 pb-4 text-12 text-gray-500">
                Tier 2 resources include workstations and endpoints, typically accessible by the end user.
            </div>
            <Tier dispatch={dispatch} save={save} fields={fields} updateAction={actions.UPDATE_TIER2} />
        </div>
    );
};

export default Tier2;
